<template>
    <div class="dashboard-container">
        <side-bar />
        <div class="main-content">
            <div class="container">
                <!--Breadcrumbs and title embedded within below data page-->
                <distributor-breadcrumbs />
            </div>
            <!-- Tabs -->
            <div class="tabs">
                <div class="tab-header">
                    <button class="tab-button" @click="activeTab = 'customers'"
                        :class="{ active: activeTab === 'customers' }">Customers</button>
                    <!-- <button class="tab-button" @click="activeTab = 'profile'"
                        :class="{ active: activeTab === 'profile' }">Profile</button> -->
                </div>
                <div class="tab-content">
                    <div v-if="activeTab === 'customers'">
                        <div class="container">
                            <h2>Customers</h2>
                            <!-- Search Input -->
                            <v-text-field v-model="search" label="Search Customers..." prepend-inner-icon="mdi-magnify"
                                variant="outlined" dense class="mb-4" hide-details></v-text-field>
                            <!-- replace this componenet  -->
                            <v-card elevation="2" class="pa-4">
                                <div class="table-wrapper">
                                    <table class="custom-table">
                                        <thead>
                                            <tr>
                                                <th v-for="header in headers" :key="header.value">
                                                    {{ header.text }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in searchedPartners" :key="item.PartnerGUID"
                                                class="table-row">
                                                <template
                                                    v-if="editingItem && editingItem.PartnerGUID === item.PartnerGUID">
                                                    <td>
                                                        <v-text-field v-model="editingItem.Company_Name" dense
                                                            hide-details variant="underlined" />
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="editingItem.Country" dense hide-details
                                                            variant="underlined" />
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="editingItem.Business_Number" dense
                                                            hide-details variant="underlined" />
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="editingItem.Currency" dense hide-details
                                                            variant="underlined" />
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="editingItem.Primary_Contact_Email" dense
                                                            hide-details variant="underlined" />
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="editingItem.Primary_Contact_Phone" dense
                                                            hide-details variant="underlined" />
                                                    </td>
                                                    <td class="actions-cell">
                                                        <v-btn icon="mdi-check" color="success"
                                                            @click="saveItem(editingItem)" variant="text"
                                                            size="small" />
                                                        <v-btn icon="mdi-close" color="error" @click="cancelEdit"
                                                            variant="text" size="small" />
                                                    </td>
                                                </template>
                                                <template v-else>
                                                    <td>
                                                        <router-link :to="`/distributor/customer`" class="customer-link"
                                                            @click="storeCustomerDetails(item)">
                                                            {{ item.Company_Name }}
                                                        </router-link>
                                                    </td>
                                                    <td>{{ item.Country }}</td>
                                                    <td>{{ item.Business_Number || '—' }}</td>
                                                    <td>{{ item.Currency }}</td>
                                                    <td>{{ item.Primary_Contact_Email }}</td>
                                                    <td>{{ item.Primary_Contact_Phone }}</td>
                                                    <!-- <td class="actions-cell">
                                                        <v-btn icon="mdi-pencil" color="primary" @click="editItem(item)"
                                                            variant="text" size="small" />
                                                        <v-btn icon="mdi-delete" color="error" @click="deleteItem(item)"
                                                            variant="text" size="small" />
                                                    </td> -->
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Loading / Empty -->
                                <v-alert v-if="partners.length === 0" type="info" class="mt-4" text>
                                    Loading partners or no data available.
                                </v-alert>

                                <!-- Pagination -->
                                <v-card-actions class="d-flex justify-space-between align-center mt-4">
                                    <span class="text-caption">
                                        Showing {{ Math.min((page - 1) * itemsPerPage + 1, filteredPartners.length) }} -
                                        {{ Math.min(page * itemsPerPage, filteredPartners.length) }} of {{
                                            filteredPartners.length }}
                                    </span>
                                    <v-pagination v-model="page" :length="pageCount" density="compact" />
                                </v-card-actions>
                            </v-card>
                        </div>
                    </div>
                    <!-- <div v-if="activeTab === 'profile'">
                        <div class="container">
                            <component src="https://c2hbe361.caspio.com/dp/76bfd000d3dd1ecbe5314687ab4f/emb"
                                :is="'script'">
                            </component>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import SideBar from './SideBar.vue'
import DistributorBreadcrumbs from '@/components/Distributor/DistributorBreadcrumbs.vue'

export default {
    name: 'PartnerDetails',
    components: {
        SideBar,
        DistributorBreadcrumbs
    },
    data() {
        return {
            activeTab: 'customers', // Default active tab
            partner: null,
            page: 1,
            search: '',
            editingItem: null,
            itemsPerPage: 10,
            headers: [
                { text: 'Company', value: 'Company_Name' },
                { text: 'Country', value: 'Country' },
                { text: 'Business Number', value: 'Business_Number' },
                { text: 'Currency', value: 'Currency' },
                { text: 'Email', value: 'Primary_Contact_Email' },
                { text: 'Phone', value: 'Primary_Contact_Phone' },
            ],
            partners: [],
        };
    },
    created() {
        // Reset bot details
        localStorage.removeItem('botName');
        localStorage.removeItem('botDisplayName');
        localStorage.removeItem('botID');
        localStorage.removeItem('botType');
        localStorage.removeItem('botDID');
        localStorage.removeItem('campaignName');
        //reset customer details
        localStorage.removeItem('customerGUID');
        localStorage.removeItem('customerName');
        
    },
    computed: {
        filteredPartners() {
            const searchLower = this.search.toLowerCase();
            return this.search
                ? this.partners.filter(p =>
                    (p.Company_Name && p.Company_Name.toLowerCase().includes(searchLower)) ||
                    (p.Country && p.Country.toLowerCase().includes(searchLower))
                )
                : this.partners;
        },
        searchedPartners() {
            const start = (this.page - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredPartners.slice(start, end);
        },
        pageCount() {
            return Math.ceil(this.filteredPartners.length / this.itemsPerPage);
        },
    },
    methods: {
        fetchPartners() {
            const payload = {
                partnerGUID: localStorage.getItem('partnerGUID') || '',
            };

            fetch(`${process.env.VUE_APP_VORTEX_PORTAL_WS}/customers/all`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            })
                .then(response => {
                    if (!response.ok) throw new Error('API error: ' + response.status);
                    return response.json();
                })
                .then(data => {
                    this.partners = data.customers || [];
                })
                .catch(error => {
                    console.error('API fetch error:', error);
                });
        },
        editItem(item) {
            this.editingItem = { ...item };
        },
        saveItem(editedItem) {
            const index = this.partners.findIndex(p => p.PartnerGUID === editedItem.PartnerGUID);
            if (index !== -1) {
                this.partners[index] = { ...editedItem };
            }
            this.editingItem = null;
        },
        cancelEdit() {
            this.editingItem = null;
        },
        deleteItem(itemToDelete) {
            const index = this.partners.findIndex(p => p.PartnerGUID === itemToDelete.PartnerGUID);
            if (index !== -1) {
                this.partners.splice(index, 1);
            }
        },
        storeCustomerDetails(item) {
            localStorage.setItem('customerName', item.Company_Name);
            localStorage.setItem('customerGUID', item.CustomerGUID);
            localStorage.setItem('customerCountry', item.Country);
            localStorage.setItem('customerBusinessNumber', item.Business_Number);
            localStorage.setItem('customerEmail', item.Primary_Contact_Email);
            localStorage.setItem('customerPhone', item.Primary_Contact_Phone);
        }
    },
    mounted() {
        this.fetchPartners();
    },
}
</script>
<style scoped>
.container.tiles {
    /* max-width: 980px; */
    margin-top: 40px;
    display: flex;
    flex-direction: row;
}

.container.lhs {
    flex: 1;
    margin-right: 20px;
}

.container.rhs {
    width: 350px;
}

.partner-details-section {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
}

.partner-details-section h2 {
    margin-top: 0;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 20px;
}

.details-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
}

.detail-item .label {
    font-weight: bold;
    margin-right: 8px;
}

.table-wrapper {
    overflow-x: auto;
}

.custom-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 800px;
}

.custom-table th,
.custom-table td {
    padding: 12px 16px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
    white-space: nowrap;
    font-size: 14px;
}

.custom-table th {
    background-color: #f4f4f4;
    font-weight: 600;
    color: #333;
}

.custom-table td:last-child {
    text-align: center;
}

.actions-cell {
    white-space: nowrap;
    width: 120px;
}

.customer-link {
    color: inherit;
    text-decoration: none;
    font-weight: 500;
    display: inline-block;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 4px 8px;
    border-radius: 6px;
}

.customer-link:hover {
    color: #e45f2b;
    text-decoration: underline;
    background-color: #f5f5f5;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
</style>